import React from 'react';
import StudentComponetsDetails from './StudentComponetsDetails';
import StudentSubComponetsDetails from './StudentSubComponetsDetails';

const StudentGradingDetails = () => {
  return (
    <div>
      <StudentComponetsDetails />
      {/* <StudentSubComponetsDetails /> */}
    </div>
  );
};

export default StudentGradingDetails;
